import { useReminderHistoryExport } from './useReminderHistoryExport';
import { useReminderHistoryList } from './useReminderHistoryList';
import type { ReminderTab } from './types';

export function useReminderHistory(initialTab: ReminderTab = 'my-history') {
  const list = useReminderHistoryList(initialTab);

  const exporter = useReminderHistoryExport({
    activeTab: list.activeTab,
    searchTerm: list.searchTerm,
    selectedSort: list.selectedSort,
    currentFilters: list.currentFilters,
  });

  return {
    ...list,
    ...exporter,
  };
}
